import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@styles/tokens.css';
import '@styles/reset.css';
import '@styles/global.css';
import '@styles/animations.css';

import App from './App';

const rootEl = document.getElementById('root');
if (rootEl === null) throw new Error('[main] Élément #root introuvable dans index.html');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
